export const getMode = () => {
  const mode = new URLSearchParams(window.location.search).get("mode");
  if (mode !== null && ["hosted", "embedded"].includes(mode) === false) {
    throw new Error(`Invalid mode: ${mode}`);
  }
  return mode;
};
